const borderRadii = {
  default: '0px',
  field: '0px',
  status: '40px'
};

export { borderRadii };
